import { useRef, useEffect } from 'react';

export const useScroll = <T extends HTMLElement>(mainScrollId?: string) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref?.current) {
      const slider = ref.current;
      const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;
      if (mainScroll) {
        if (mainScroll !== slider) {
          slider.scrollLeft = mainScroll.scrollLeft;
        }
      }
    }
  }, [mainScrollId]);

  useEffect(() => {
    if (ref?.current) {
      const slider = ref.current;
      const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;

      const onScroll = (_e: Event) => {
        if (mainScroll) {
          if (mainScroll !== slider) {
            mainScroll.scrollLeft = slider.scrollLeft;
          }
        }
      };

      const onMainScroll = (element: Element) => {
        slider.scrollLeft = element.scrollLeft;
      };

      if (mainScroll) {
        if (mainScroll !== slider) {
          mainScroll.addEventListener('scroll', () => onMainScroll(mainScroll));
        }
      }
      slider.addEventListener('scroll', onScroll);
      return () => {
        if (mainScroll) {
          if (mainScroll !== slider) {
            mainScroll.removeEventListener('scroll', () => onMainScroll(mainScroll));
          }
        }
        slider.removeEventListener('scroll', onScroll);
      };
    }
  }, [mainScrollId]);

  return { ref };
};
